import { render } from "./BehaviorSearchBox.vue?vue&type=template&id=6bbe48d7&scoped=true"
import script from "./BehaviorSearchBox.vue?vue&type=script&lang=js"
export * from "./BehaviorSearchBox.vue?vue&type=script&lang=js"

import "./BehaviorSearchBox.vue?vue&type=style&index=0&id=6bbe48d7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbe48d7"]])

export default __exports__